"use client"

import * as timeago from "timeago.js"
import ar from "timeago.js/lib/lang/ar"
import ReactTimeAgo, { TimeAgoProps } from "timeago-react"

export const registerTimeAgoLocales = () => {
  timeago.register("ar", ar)
}

export type ReactTimeAgoProps = TimeAgoProps
export { ReactTimeAgo }
